"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockTimestampFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockTimestampFactory = /** @class */ (function (_super) {
    __extends(MockTimestampFactory, _super);
    function MockTimestampFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockTimestampFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockTimestampFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockTimestampFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockTimestampFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockTimestampFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockTimestampFactory;
}(contracts_1.ContractFactory));
exports.MockTimestampFactory = MockTimestampFactory;
var _abi = [
    {
        constant: true,
        inputs: [],
        name: "currentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_timestamp",
                type: "uint256",
            },
        ],
        name: "setCurrentTimestamp",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x60806040526000805534801561001457600080fd5b50610112806100246000396000f3fe6080604052348015600f57600080fd5b506004361060325760003560e01c80631e2ff94f14603757806366efcb78146051575b600080fd5b603d6062565b6040516048919060ac565b60405180910390f35b6060605c366004607c565b6068565b005b60005490565b600055565b803560768160bb565b92915050565b600060208284031215608d57600080fd5b600060978484606d565b949350505050565b60a68160b8565b82525050565b6020810160768284609f565b90565b60c28160b8565b811460cc57600080fd5b5056fea365627a7a72315820482494fa746215d3c577bac05bdf4435b519b9477310a1744d164e4fff726b786c6578706572696d656e74616cf564736f6c63430005100040";
